import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SelfMapObjectKeys } from '@cm/utility';

const pathStart = 'Reporting|Newly Imported Exams|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPReportingNewlyImportedExams';
export type SPReportingNewlyImportedExamsLocNames =
	| `${LocNameStart}ContentPageDescription`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}ButtonViewDetails`
	| `${LocNameStart}LabelImportDate`
	| `${LocNameStart}LabelDataProvider`
	| `${LocNameStart}LabelTotal`
	| `${LocNameStart}LabelDetails`;

export const spReportingNewlyImportedExamsLocs: LocDefs<SPReportingNewlyImportedExamsLocNames> = {
	SPReportingNewlyImportedExamsContentPageDescription: {
		defaultValue:
			'This page only shows the first 300 records, to search for more, please use the search options in the menu under candidate search.',
		description: 'Page description',
		displayPath: `${pathStart}Page Description`,
		displayType: 'Content',
		...sharedProperties,
		htmlAllowed: true,
	},
	SPReportingNewlyImportedExamsTitleSection: {
		defaultValue: 'Newly Imported Exams',
		description: 'Section title',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		legacyName: 'Exam/Reporting.NewlyImportedExams.Title.SectionTitle',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsTitleTab: {
		defaultValue: 'Newly Imported Exams Report',
		description: 'Tab title',
		displayPath: `${pathStart}Tab title`,
		displayType: 'Title',
		legacyName: 'Exam/Reporting.NewlyImportedExams.Title.TabTitle',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsTitlePage: {
		defaultValue: 'Newly Imported Exams Report',
		description: 'Page title',
		displayPath: `${pathStart}Page title`,
		displayType: 'Title',
		legacyName: 'Exam/Reporting.NewlyImportedExams.Title.PageTitle',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsButtonViewDetails: {
		defaultValue: 'View',
		description: 'View details button',
		displayPath: `${pathStart}View Details`,
		displayType: 'Button',
		legacyName: 'Exam/Reporting.NewlyImportedExams.Button.View',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsLabelImportDate: {
		defaultValue: 'Import Date',
		description: 'Column heading for: Import Date.',
		displayPath: `${pathStart}Import Date`,
		displayType: 'Label',
		legacyName: 'Exam/Reporting.NewlyImportedExams.ColumnHeading.ImportDate',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsLabelDataProvider: {
		defaultValue: 'Data Provider',
		description: 'Column heading for: Data Provider.',
		displayPath: `${pathStart}Data Provider`,
		displayType: 'Label',
		legacyName: 'Exam/Reporting.NewlyImportedExams.ColumnHeading.DataProvider',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsLabelTotal: {
		defaultValue: 'Total',
		description: 'Column heading for: Total.',
		displayPath: `${pathStart}Total`,
		displayType: 'Label',
		legacyName: 'Exam/Reporting.NewlyImportedExams.ColumnHeading.Total',
		...sharedProperties,
	},
	SPReportingNewlyImportedExamsLabelDetails: {
		defaultValue: 'Details',
		description: 'Column heading for: Details.',
		displayPath: `${pathStart}Details`,
		displayType: 'Label',
		legacyName: 'Exam/Reporting.NewlyImportedExams.ColumnHeading.Detail',
		...sharedProperties,
	},
};

export const LOC_KEYS = SelfMapObjectKeys(spReportingNewlyImportedExamsLocs);
export type SPReportingNewlyImportedExamsLocType = LocMap<SPReportingNewlyImportedExamsLocNames>;
